import { Component, HostListener, Input, Output, ViewChild, ViewChildren, ElementRef, QueryList, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { PagerService } from '@app/services/pager.service';
import { CommonService } from '@app/services/common.service';
import { DevicesService } from '@app/services/devices.service';
import { Helper } from '../../../../../4services/2helper'
import { c_components } from 'src/3ui/2components';
import ims from '../../imports'
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_dtable_device_health',
    templateUrl: './c_dtable_device_health.component.html',
    styleUrls: ['../../common.scss', './c_dtable_device_health.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class c_dtable_device_health_component extends BaseComponent {
  @Input() deviceList: any[];
  @Input() isLoading: boolean;
  @Output() refresh = new EventEmitter<boolean>();
  @ViewChild('selectDropdown') selectDropdown: ElementRef;
  @ViewChildren('statusFilterbox', {read: ElementRef}) statusFilterbox: QueryList<any>
  @ViewChildren('typeFilterbox', {read: ElementRef}) typeFilterbox: QueryList<any>
  @ViewChildren('siteFilterbox', {read: ElementRef}) siteFilterbox: QueryList<any>
  @ViewChildren('deviceActionMenus') deviceActionMenus: QueryList<any>
//-----------------------------------------------------------------------------

  tableHeader = [
    { name: 'Site ID', value: 'site_id', width: "6%" },
    { name: 'Site Name', value: 'site_name', width: "15%" },
    { name: 'Device Type', value: 'type', width: "7%" },
    { name: 'Zone Number', value: 'zone_number', width: "8%" },
    { name: 'Device Name', value: 'device_name', width: "15%" },
    { name: 'Brand', value: 'brand', width: "7%" },
    { name: 'Model', value: 'model', width: "10%" },
    { name: 'Firmware', value: 'firmware', width: "10%" },
    { name: 'Status', value: 'status', width: "6%" },
    { name: 'Status Date', value: 'status_date', width: "10%"},
    { name: '', value: null, width: "5%"}
  ]

  filteredDeviceList = [];
  activatedSitesDeviceList = [];
  originalDeviceList = [];
  pagedItems = [];

  // Filter
  isFocusSearch = false;
  searchText = '';
  searchSiteText = '';
  showStatusFilterbox = false;
  showTypeFilterbox = false;
  showSiteFilterbox = false;
  siteList = [];
  filteredSiteList = [];

  selectedStatus = 'All';
  selectedType = [];
  selectedSite = null;
  statusFilterItems = ['All', 'Online', 'Offline'];
  typeFilterItems = ['Audio', 'Bridge', 'Camera'];

  // CSV
  isLoadingForCSV = false;

  // Pager
  pager: any = {};
  curPage = 1;
  totalItem = 0;
  pageOffset = 50;
  pageOffsetStart = 1;
  pageOffsetEnd = 1;
  lastPage = 1;

  constructor(
    public pagerService : PagerService,
    public commonService: CommonService,
    public c_components: c_components,
    public helper: Helper,
  ) { super(); }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.deviceActionMenus) {
      const deviceActionMenus = this.deviceActionMenus.toArray();
      deviceActionMenus.forEach(actionMenu => {
        this.pagedItems.forEach((device, i)=> {
          if (`device-${i}${device.device_name}` === actionMenu.nativeElement.id) {
            if (!actionMenu.nativeElement.contains(event.target)) {
              device.isShowMenu = false;
            }
          }
        })
      })
    }
    if (this.selectDropdown) {
      if (!this.selectDropdown.nativeElement.contains(event.target)) {
        event.stopPropagation()
      }
    }
    if (this.statusFilterbox) {
      const statusFilterbox = this.statusFilterbox.toArray();
      statusFilterbox.forEach(filterbox => {
        if (!filterbox.nativeElement.contains(event.target)) {
          this.showStatusFilterbox = false;
        }
      })
    }
    if (this.typeFilterbox) {
      const typeFilterbox = this.typeFilterbox.toArray();
      typeFilterbox.forEach(filterbox => {
        if (!filterbox.nativeElement.contains(event.target)) {
          this.showTypeFilterbox = false;
        }
      })
    }
    if (this.siteFilterbox) {
      const siteFilterbox = this.siteFilterbox.toArray();
      siteFilterbox.forEach(filterbox => {
        if (!filterbox.nativeElement.contains(event.target)) {
          this.showSiteFilterbox = false;
        }
      })
    }
  }

  ngOnChanges(changes): void {
    if(changes.deviceList){
      this.originalDeviceList = [...this.deviceList];
      const activatedDevices = this.deviceList.filter(device => device.is_activated_site);
      this.activatedSitesDeviceList = [...activatedDevices];
      this.filteredDeviceList = [...activatedDevices];

      this.siteList = Array.from(
        new Map(
          this.activatedSitesDeviceList.map(({ site_id, site_name }) => [site_id, { site_id, site_name }])
        ).values()
      );
      this.filteredSiteList = this.siteList;

      this.setPage(1)
    }
  }

  // --------------------------------------------------------------------------------
  //position
  setMorePosition(e, device, index) {
    const docElem = document.documentElement
    let elem = document.getElementById('device-' + index + device.device_name);
    let more = document.getElementById('more-device-' + index + device.device_name);
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right - 10;
    const posY = rect.bottom + 7;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }

  trackByDevice(index: number, device: any): string {
    return `${device.site_id}-${device.zone_number}-${device.device_name}`;
  }

  goToSiteDevices(siteId) {
    this.helper.router.navigate_to('/customers/devices/device-list', { id: siteId });
  }

  toggleMenu(device){
    const targetMenu = device.isShowMenu;
    device.isShowMenu = !targetMenu;
  }

  computedStyleForOnline(device){
    return device.is_online ? 'online' : 'offline';
  }

  computedPlanBadgeStyle(isActivatedDevicePlan, plan){
    if(!isActivatedDevicePlan) return 'basic-badge'
    switch(plan){
      case 1: return 'first-plan-badge'
      case 2: return 'second-plan-badge'
      default: return 'basic-badge'
    }
  }

  setSearchFocus() {
    this.isFocusSearch = true;
  }

  selectSite(site) {
    this.selectedSite = site;
    this.applyFilter();
    this.showSiteFilterbox = false;
  }

  clearSiteFilter() {
    this.selectedSite = null;
    this.applyFilter();
  }

  searchSite(searchSiteText) {
    this.filteredSiteList = this.siteList.filter(site => site.site_name.toLowerCase().indexOf(searchSiteText.toLowerCase()) > -1);
  }

  search(){
    this.applyFilter()
  }

  searchDevice(list) {
    const search_text = this.searchText.toLowerCase();

    if (!search_text || search_text.length < 3) {
      return list;
    }

    return list.filter(device => {
      const text =
        (device.name || "").toLowerCase() +
        (device.site_name || "").toLowerCase() +
        String(device.site_id || "");

      return text.includes(search_text);
    });
  }

  toggleStatusFilter() {
    this.showStatusFilterbox = !this.showStatusFilterbox;
  }

  toggleTypeFilter() {
    this.showTypeFilterbox = !this.showTypeFilterbox;
  }

  toggleSiteFilter() {
    this.showSiteFilterbox = !this.showSiteFilterbox;
  }

  hasTypeFilter(type) {
    return this.selectedType.includes(type);
  }

  selectTypeItem(item) {
    const index = this.selectedType.indexOf(item);

    if (index > -1) {
      this.selectedType.splice(index, 1);
    } else {
      this.selectedType.push(item);
    }

    this.applyFilter()
  }

  applyFilter() {
    let listData = this.activatedSitesDeviceList;

    // Status
    if (this.selectedStatus === 'Online') {
      listData = listData.filter(device => device.status === 'Online');
    }
    if (this.selectedStatus === 'Offline') {
      listData = listData.filter(device => device.status === 'Offline');
    }

    // Type
    if (this.selectedType.length !== 0) {
      listData = listData.filter(device => this.selectedType.includes(device.type));
    }

    // Site
    if (this.selectedSite) {
      listData = listData.filter(device => device.site_id === this.selectedSite.site_id)
    }

    // Search
    listData = this.searchDevice(listData);

    this.filteredDeviceList = listData;
    this.setPage(1);
  }

  // -----------------------------------------------------------------------------
  compare(a: number | string | null, b: number | string | null, isAsc: boolean) {
    if (a === null && b === null) return 0;
    if (a === null) return isAsc ? -1 : 1;
    if (b === null) return isAsc ? 1 : -1;

    if (typeof a === 'string') a = a.toLocaleLowerCase();
    if (typeof b === 'string') b = b.toLocaleLowerCase();

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortTableByColumn(sortTarget) {
    if (!sortTarget.sortColumn || sortTarget.sortDirection === '') {
      return;
    }
    let data = this.filteredDeviceList;

    const tmpData = data.sort((a, b) => {
      const isAsc = sortTarget.sortDirection === 'asc';
      switch (sortTarget.sortColumn) {
        case 'site_id':
          return this.compare(a.site_id, b.site_id, isAsc);
        case 'site_name':
          return this.compare(a.site_name, b.site_name, isAsc);
        case 'type':
          return this.compare(a.type, b.type, isAsc);
        case 'zone_number':
          return this.compare(a.zone_number, b.zone_number, isAsc);
        case 'device_name':
          return this.compare(a.device_name, b.device_name, isAsc);
        case 'brand':
          return this.compare(a.brand, b.brand, isAsc);
        case 'model':
          return this.compare(a.model, b.model, isAsc);
        case 'firmware':
          return this.compare(a.firmware, b.firmware, isAsc);
        case 'status':
          return this.compare(a.status, b.status, isAsc);
        case 'status_date':
          return this.compare(a.status_date, b.status_date, isAsc);
        default: return 0;
      }
    });

    this.pagedItems = tmpData;
    this.setPage(1)
  }

  setPage(page: number) {
    this.pagedItems = []
    const target = this.filteredDeviceList
    if(!target){
      console.debug('⚠️ list is lost', target)
      return this.isLoading = false
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(target?.length, page, this.pageOffset);
    this.totalItem = target?.length;

    // get current page of items
    this.pagedItems = target.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.curPage = this.pager.currentPage;
    if (this.curPage -1 < 0) {
      this.pageOffsetStart = 0;
    } else if (this.curPage -1 == 0) {
      this.pageOffsetStart = 1;
    } else {
      this.pageOffsetStart =  (this.curPage -1) * this.pageOffset +1;
    }

    if (this.curPage * this.pageOffset > this.totalItem) {
      this.pageOffsetEnd =  this.totalItem;
    } else {
      this.pageOffsetEnd =  this.curPage * this.pageOffset;
    }
  }

  selectStatusFilter(status) {
    this.selectedStatus = status;
    this.applyFilter()
    this.showStatusFilterbox = false;
  }

  sortDealerDeviceList(dealerDeviceList){
    return dealerDeviceList.sort((a, b) => {
      // site_id 순으로 정렬
      if (a.site_id < b.site_id) return -1;
      if (a.site_id > b.site_id) return 1;

      // site_name 순으로 정렬
      if (a.site_name < b.site_name) return -1;
      if (a.site_name > b.site_name) return 1;

      // device_name 순으로 정렬
      if (a.device_name < b.device_name) return -1;
      if (a.device_name > b.device_name) return 1;

      // 모든 값이 같으면 0 반환 (변경 없음)
      return 0;
    });
  }

  getCSVData() {
    const header = this.tableHeader.map(header => {
      return header.name ? header.name : 'Site Status'
    });

    const sortedDeviceList = this.sortDealerDeviceList(this.filteredDeviceList);

    let row = [];
    sortedDeviceList.forEach(device => {
      let newRow = [
        device.site_id,
        device.site_name,
        device.type,
        device.zone_number,
        device.device_name,
        device.brand,
        device.model,
        device.firmware,
        device.status,
        device.status_date,
        device.is_activated_site ? 'Activated' : 'Deactivated'
      ]
      row.push(newRow);
    })

    return { header, row }
  }

  createCSV() {
    this.isLoadingForCSV = true
    const { header, row } = this.getCSVData();

    const rows = [header, ...row];
    let csvContent = rows.map(row =>
      row.map(field => `"${field?.toString().replace(/"/g, '""')}"`).join(",")
    ).join("\n");

    const encodedUri = "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
    const today = ims.moment().format('YYYY-MM-DD');
    const filename = `Device Health Report(${today}).csv`
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    document.body.appendChild(link);

    this.isLoadingForCSV = false;
    link.click()
  }
}
